module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"select_image":"选取图片","image_size":"图片尺寸：","preview":"预览"},"en":{"select_image":"Select Image","image_size":"Image size: ","preview":"Preview"}}')
  delete Component.options._Ctor
}
